import cx from 'classnames';
import React from 'react';
export const PopoverContainer = ({ anchorSide = 'block-start', embedded, inline, children, className, containerRef, ...rest }) => (React.createElement("div", { className: cx('tds-popover-container', {
        [`tds-popover-container--anchor-side-${anchorSide}`]: anchorSide,
        'tds-popover-container--embedded': embedded,
        'tds-popover-container--inline': inline,
    }, className), ref: containerRef, ...rest }, children));
